// import UpdateStore from "views/Dashboard/Store/UpdateStore";

// export const authRouteConstants = {
//   HOME: "/",
//   CONATCT: "/contact",
//   PRICING: "/pricing",
//   ABOUT: "/about",
//   FAQ:"/faq",
//   PRIVACYPOLICYV1: "/privacy-policy",
//   PRIVACYPOLICY: "/returnandrefunds",
//   TERMSANDCONDISTION: "/termsandcondition",
//   PARTNERS: "/partners",
//   PAYMENTS: "/integrations/payments",
//   PILOTPOS: "/pilot/credentials/pilot-pos/",
//   SHIPPINGINTEGRATION: "/integrations/shipping",
//   SOLUTIONQRCODE:"/solutions/digital-menu",
//   TABLEORDERING:"/solutions/table-ordering",
//   PRODUCTS:"/solutions/ecommerce-store",
//   TUCKSHOP:"/solutions/tuckShop",
//   AUTH: "/auth",
//   LOGIN: "/auth/login",
//   SIGNUP: "/auth/signup",
//   FORGOTPASSWORD: "/auth/forgot-password",
//   LOGOUT: "/auth/logout",
// };

// export const dashboardRouteConstants = {
//   INITIAL_SETUP: "/initial-setup",
//   HOME: "/dashboard",
//   tutorial:"/dashboard/tutorial",
//   help:"/dashboard/help",
//   WEBSITE: "/website",
//   WEB_ANALYTICS: "/website/analytics",
//   WEB_TEMPLATE: "/website/templates",
//   CUSTOM_WEB_TEMPLATE: "/website/customtemplates",
//   DOMAIN: "/website/domain",
//   CONTACT: "/website/contact",
//   ABOUT: "/website/about",
//   WEB_TERMS_AND_CONDITION: "/website/terms-conditions",
//   STORE_ANALYTICS: "/store/analytics",
//   PRODUCTS: "/store/products",
//   CATEGORIES: "/store/categories",
//   UpdateStore: "/store/updatestore",
//   CUSTOMERS: "/reports/customers",
//   ORDERS: "/reports/orders", 
//   SALESREPORT: "/reports/salesReport", 
//   ANALYTICS: "/reports/analytics",
//   INVENTORYREPORT: "/reports/inventoryReport", 
//   VOUCHERS: "/marketing/vouchers",
//   QRCODE: "/marketing/qrCode",
//   PAYMENTS: "/store/integrations/payments",
//   PILOTPOS: "/store/integrations/pilot-pos",
//   SHIPPING: "/store/shipping",
//   DELIVERY: "/store/delivery",
//   REVIEWS: "/store/reviews",
//   ACC_DETAIL: "/account/details",
//   BILLING_DETAIL: "/account/billing",
//   MY_STORE: "/account/store",
//   PRIVACY_POLICY:"/website/returnandrefunds",
//   REFUND_POLICY:"/website/refundpolicy"
// };

// export const APIRouteConstants = {
//   AUTH: {
//     SIGNUP: "/accounts/merchant-create",
//     LOGIN: "/accounts/merchant-login",
//     ME: "/accounts/me/merchant",
//     FORGOTPASSEMAIL: "/core/email_for_forgotpassword/",
//     OTPVALIDATECHANGEPASSWORD: "/core/verify-otp-resetpassword/",
//     RESETPASSWORD: "/core/reset-password/",
//     EMAILOTPVERIFY: "/accounts/verify-otp-for-email/",
//     MERCHANT_USER: "/accounts/merchants-user-account/",
//   },
//   WEBSITE: {
//     WEB_DETAILS: "/accounts/add/website-detail",
//     WEB_LOGO_BANNER: "/accounts/logo-banner/",
//     WEB_DOMAIN: "/accounts/website-domain/",
//     WEB_CONTACTS: "/accounts/contact-detail/",
//     WEB_ABOUT_US: "/accounts/about-us-website/",
//     WEB_TERMS_AND_CONDITION: "/accounts/terms-and-conditions/",
//     ADD_WEB_DETAILS: "/accounts/add/website-detail",
//     UPDATE_STORE: "/accounts/merchant/store-setup/complete",
//     PUBLISH_WEBSITE: "/accounts/IsPublished-update/",

//     SPECIAL_SALE:"/accounts/update_special_sale/",
//     UPLOAD_CUSTOM_IMAGE:"/accounts/upload-images-and-text/",
//     COMMUNITY:"/accounts/promo-text-update/",
//     PRIVACY_POLICY:"/accounts/privacy_policy/",
//   },
//   SHIPRAZOR: {
//     SR_ACCOUNT: "/shiprazor/check-shiprazor-account/",
//     VERIFY_OTP: "/shiprazor/user-otp-verify-api/",
//     ADD_VENDORE_SHIPRAZOR:"/shiprazor/update-shiprazor-vendor-api-key/",
//     ADD_API_KEY: "/shiprazor/store-shiprazor-api-key/",
//     GET_ADDRESSES: "/shiprazor/shiprazor-pickup-addresses",
//     GET_SHIPRAZOR_STATUS: "/accounts/get-shiprazor-status/",
//     UPDATE_SHIPRAZOR_STATUS: "/accounts/shiprazor-status-update/",
//     UPDATE_OWNSHIPPING_STATUS: "/accounts/update-ownshipping-status/",
//     GET_SHIPPING_AMOUNT: "/accounts/get-shipping-amount/",
//     ADD_SHIPPING_AMOUNT: "/accounts/add-shipping-amount/",
//     PICK_UP_AT_STORE: "/accounts/update-pickup-status/",
//     UPDATE_WAREHOUSE: "/accounts/update-website-settings/",
//   },
//   STORE: {
//     SALES_ANALYTICS: "/transaction/sale-summary/",
//     TOP_COLLECTION: "/product/best-selling-product-list/",
//     ALL_PRODUCTS: "/product/merchant/products/",
//     ADD_PRODUCT: "/product/merchant/products/",
//     GET_PRODUCT: (id) => `/product/merchant-product-update/${id}`,
//     UPDATE_PRODUCT: (id) => `/product/merchant-product-update/${id}`,
//     SEARCH_CATEGORIES: "/core/all_product_categories_without_pagination/",
//     ALL_CATEGORIES: "/core/all-category-list/",
//     ADD_CATEGORY: "/product/product-categories/",
//     ALL_CUSTOMERS: "/customer/customer-list/",
//     ALL_ORDERS: "/core/merchant_orders/",
//     ALL_ORDERS_DASHBOARD: "/accounts/transaction-list/",
//     GET_ORDER: (id) => `/accounts/order/${id}/`,
//     UPDATE_ORDER: "/accounts/order/update_status/",
//     UPDATE_PAYMENT_STATUS: "/accounts/update-payment-status/",
//     ALL_VOUCHERS: "/core/vouchers-list/",
//     ADD_VOUCHER: "/accounts/create-voucher/",
//     UPDATE_VOUCHER: (id) => `/accounts/vouchers/${id}/`,
//     SEND_OTP_VOUCHER: "/accounts/send-otp-for-voucher",
//     ALL_PAYMENT_MODES: "/accounts/payment-methods/",
//     UPDATE_STORE_STATUS: "/accounts/update/store-status",
//     UPDATE_PAYMENT_MODE: (id) => `/accounts/select-payment-mode/${id}/`,
//     GET_PEACH_CREDENTIAL: "/accounts/peachcredentials/",
//     GET_STICITT_CREDENTIAL: "/sticitt_pay/update-sticitt-creds/",
//     SET_PEACH_CREDENTIAL: "/accounts/peachcredentials/",
//     SET_STICITT_CREDENTIAL: "/sticitt_pay/update-sticitt-creds/",
//     GET_CREDENTIALS: "/api/credentials/",
//     SET_CREDENTIALS: "/api/credentials/",
//     ALL_LOGISTIC_OPTIONS: "/core/logistic-service-details/",
//     // UPDATE_DELIVERY_OPTION: "",
//     GET_DELIVERY_LOCATION: "/accounts/add/merchant-address",
//     UPDATE_DELIVERY_LOCATION: "/accounts/add/merchant-address",
//     ALL_REVIEWS: "/core/reviews/",
//     UPLOAD_BULK_CATEGORIES: "/product/bulk-upload-categories/",
//     DELETE_CATEGORIY:(id) => `/product/delete-category-&-childrens/${id}`,
//     UPDATE_CATEGORY: (id) => `/product/update-category/${id}`,
//     DELETE_PRODUCT: (id) => `/product/delete-product/${id}`,
//     DELETE_PRODUCT_VARIANT: (id) => `/product/delete-variant/${id}/`,
//     UPLOAD_BULK_PRODUCTS: "/product/bulk-upload-products/",
//     CREATEQR: "/accounts/qr-code/generate/",
//     QRDOWNLOAD: "/accounts/qr-codes/download/",
//     EXISTINGQR: "accounts/qr-code/generate/?scenario=BULK",
//     SUBSCRIPTION_PLAN: "/accounts/subscription-cta-mail/",
//   },
//   ACCOUNT: {
//     ALL_PLANS: "/core/subscription-list",
//     UPDATE_PLAN: "/accounts/add/merchant-subscription",
//     ALL_INVOICES: "",

//   },
//   LANDING: {
//     SUBSCRIBE: "/core/subscribe/",
//     FEEDBACK: "/core/feedback/",
//   },
// };

// import UpdateStore from "views/Dashboard/Store/UpdateStore";

export const authRouteConstants = {
  HOME: "/",
  CONATCT: "/contact",
  PRICING: "/pricing",
  ABOUT: "/about",
  FAQ: "/faq",
  PRIVACYPOLICYV1: "/privacy-policy",
  PRIVACYPOLICY: "/returnandrefunds",
  TERMSANDCONDISTION: "/termsandcondition",
  EULA: "/eula",
  PARTNERS: "/partners",
  PAYMENTS: "/integrations/payments",
  PILOTPOS: "/pilot/credentials/pilot-pos/",
  SHIPPINGINTEGRATION: "/integrations/shipping",
  SOLUTIONQRCODE: "/solutions/digital-menu",
  TABLEORDERING: "/solutions/table-ordering",
  PRODUCTS: "/solutions/ecommerce-store",
  TUCKSHOP: "/solutions/tuckShop",
  NEWS_UPDATES: "/blog",
  BLOG_ARTICLE: "/blog/:slug",
  ARTICLE_1: "/blog/restaurant-pos-system-2026",
  ARTICLE_2: "/blog/webbieshop-zapper-digital-ordering-payment-solution",
  ARTICLE_3: "/blog/cashless-school-tuckshop-webbieshop-sticitt",
  ARTICLE_4: "/blog/d6-webbieshop-cashless-school-system",
  ARTICLE_5: "/blog/webbieshop-pre-booking-order-school-breaks",
  ARTICLE_6: "/blog/team-management-role-based-access-control-system",
  AUTH: "/auth",
  LOGIN: "/auth/login",
  SIGNUP: "/auth/signup",
  FORGOTPASSWORD: "/auth/forgot-password",
  LOGOUT: "/auth/logout",
};

export const dashboardRouteConstants = {
  INITIAL_SETUP: "/initial-setup",
  HOME: "/dashboard",
  DASHBOARD_ORDER_LIST: "/dashboard?tab=order-list",
  DASHBOARD_POS: "/dashboard?tab=pos",
  tutorial: "/dashboard/tutorial",
  help: "/dashboard/help",
  WEBSITE: "/website",
  WEB_ANALYTICS: "/website/analytics",
  WEB_TEMPLATE: "/website/templates",
  CUSTOM_WEB_TEMPLATE: "/website/customtemplates",
  DOMAIN: "/website/domain",
  CONTACT: "/website/contact",
  ABOUT: "/website/about",
  WEB_TERMS_AND_CONDITION: "/website/terms-conditions",
  STORE_ANALYTICS: "/store/analytics",
  PRODUCTS: "/store/products",
  CATEGORIES: "/store/categories",
  UpdateStore: "/store/updatestore",
  CUSTOMERS: "/reports/customers",
  ORDERS: "/reports/orders",
  SALESREPORT: "/reports/salesReport",
  ANALYTICS: "/reports/analytics",
  INVENTORYREPORT: "/reports/inventoryReport",
  SUBUSERREPORT: "/reports/subuser-report",
  EXECUTIVEREPORT: "/reports/executive-report",
  VOUCHERS: "/marketing/vouchers",
  QRCODE: "/marketing/qrCode",
  PAYMENTS: "/store/integrations/payments",
  PILOTPOS: "/store/integrations/pilot-pos",
  ORDERNOTE: "/store/order-note",
  TIPSETTINGS: "/store/tip-settings",
  ADDON_GROUPS: "/store/addon-groups",
  RAW_MATERIALS: "/store/raw-materials",
  RECIPES: "/store/components-resources",
  SHIPPING: "/store/integrations/shipping",
  DELIVERY: "/store/delivery",
  REVIEWS: "/store/reviews",
  SUBUSERS: "/account/subusers",
  ACC_DETAIL: "/account/details",
  BILLING_DETAIL: "/account/billing",
  MY_STORE: "/account/store",
  PRIVACY_POLICY: "/website/returnandrefunds",
  REFUND_POLICY: "/website/refundpolicy",
  DEALS: "/marketing/deals"
};

export const APIRouteConstants = {
  AUTH: {
    SIGNUP: "/accounts/merchant-create",
    LOGIN: "/accounts/merchant-login",
    ME: "/accounts/me/merchant",
    SIDE_BAR: "/api/permissions",
    FORGOTPASSEMAIL: "/core/email_for_forgotpassword/",
    OTPVALIDATECHANGEPASSWORD: "/core/verify-otp-resetpassword/",
    RESETPASSWORD: "/core/reset-password/",
    EMAILOTPVERIFY: "/accounts/verify-otp-for-email/",
    MERCHANT_USER: "/accounts/merchants-user-account/",
    SIDE_BAR: "/api/permissions",
  },
  WEBSITE: {
    WEB_DETAILS: "/accounts/add/website-detail",
    WEB_LOGO_BANNER: "/accounts/logo-banner/",
    WEB_DOMAIN: "/accounts/website-domain/",
    WEB_CONTACTS: "/accounts/contact-detail/",
    WEB_ABOUT_US: "/accounts/about-us-website/",
    ORDERNOTE_FEATURE: "/accounts/order-note-changes/",
    WEB_TERMS_AND_CONDITION: "/accounts/terms-and-conditions/",
    ADD_WEB_DETAILS: "/accounts/add/website-detail",
    UPDATE_STORE: "/accounts/merchant/store-setup/complete",
    PUBLISH_WEBSITE: "/accounts/IsPublished-update/",
    SPECIAL_SALE: "/accounts/update_special_sale/",
    UPLOAD_CUSTOM_IMAGE: "/accounts/upload-images-and-text/",
    COMMUNITY: "/accounts/promo-text-update/",
    PRIVACY_POLICY: "/accounts/privacy_policy/",
    SPECIAL_SALE: "/accounts/update_special_sale/",
    UPLOAD_CUSTOM_IMAGE: "/accounts/upload-images-and-text/",
    COMMUNITY: "/accounts/promo-text-update/",
    PRIVACY_POLICY: "/accounts/privacy_policy/",
    LANGUAGES: "/core/languages/",
    BREAK_TYPES: "/core/break-types/",
    MERCHANT_BREAKS: "/core/merchant-breaks/",
  },
  SHIPRAZOR: {
    SR_ACCOUNT: "/shiprazor/check-shiprazor-account/",
    VERIFY_OTP: "/shiprazor/user-otp-verify-api/",
    ADD_VENDORE_SHIPRAZOR: "/shiprazor/update-shiprazor-vendor-api-key/",
    ADD_API_KEY: "/shiprazor/store-shiprazor-api-key/",
    GET_ADDRESSES: "/shiprazor/shiprazor-pickup-addresses",
    GET_SHIPRAZOR_STATUS: "/accounts/get-shiprazor-status/",
    UPDATE_SHIPRAZOR_STATUS: "/accounts/shiprazor-status-update/",
    UPDATE_OWNSHIPPING_STATUS: "/accounts/update-ownshipping-status/",
    GET_SHIPPING_AMOUNT: "/accounts/get-shipping-amount/",
    ADD_SHIPPING_AMOUNT: "/accounts/add-shipping-amount/",
    PICK_UP_AT_STORE: "/accounts/update-pickup-status/",
    UPDATE_WAREHOUSE: "/accounts/update-website-settings/",
  },
  STORE: {
    TRANSACTION_INCOME_GRAPH: "/transaction/income-graph/",
    INCOME_REPORT: "/transaction/income-report/",
    SALES_ANALYTICS: "/transaction/sale-summary/",
    TOP_COLLECTION: "/product/best-selling-product-list/",
    ALL_PRODUCTS: "/product/merchant/products/",
    ADD_PRODUCT: "/product/merchant/products/",
    GET_PRODUCT: (id) => `/product/merchant-product-update/${id}`,
    UPDATE_PRODUCT: (id) => `/product/merchant-product-update/${id}`,
    SEARCH_CATEGORIES: "/core/all_product_categories_without_pagination/",
    ALL_CATEGORIES: "/core/all-category-list/",
    ADD_CATEGORY: "/product/product-categories/",
    ALL_CUSTOMERS: "/customer/customer-list/",
    ALL_ORDERS: "/core/merchant_orders/",
    ALL_ORDERS_DASHBOARD: "/accounts/transaction-list/",
    DASHBOARD_TRANSACTIONS: "/accounts/dashboard/transactions/",
    SUBUSER_ORDERS_REPORT: "/core/subuser_orders_report/",
    CUSTOM_ORDER_REPORT: "/core/custom_order_report",
    SALES_REPORT_EMAIL: "/core/sales_report",
    CUSTOMER_REPORT_EMAIL: "/core/customer-report",
    INVENTORY_REPORT_EMAIL: "/core/inventory-report",
    EXECUTIVE_REPORT_EMAIL: "/core/executive-report",
    GET_ORDER: (id) => `/accounts/order/${id}/`,
    UPDATE_ORDER: "/accounts/order/update_status/",
    // Emails the invoice for a whole transaction to the customer. The backend
    // renders the PDF and sends it — the FE just passes the transaction id, the
    // recipient email and the merchant's local timezone. WhatsApp sharing is
    // client-only and does NOT hit this. Online-only (offline POS never calls it).
    // Body: { transaction_id (with "webbie-" prefix), cu_emailid, merchant_timezone }
    // Response: { message: "Invoice email is being sent." }
    SEND_INVOICE: "/transaction/invoice/mail/",
    UPDATE_PAYMENT_STATUS: "/accounts/update-payment-status/",
    SEND_OTP_PAYMENT_MODE_CHANGE: "/accounts/send-otp-paymentmode-change/",
    ALL_VOUCHERS: "/core/vouchers-list/",
    ADD_VOUCHER: "/accounts/create-voucher/",
    UPDATE_VOUCHER: (id) => `/accounts/vouchers/${id}/`,
    SEND_OTP_VOUCHER: "/accounts/send-otp-for-voucher",
    ALL_PAYMENT_MODES: "/accounts/payment-methods/",

    // terminal (sticitt and peach)
    TERMINAL_LIST: "sticitt_pay/terminal-list/",
    SAVE_LAST_USED_TERMINAL: "sticitt_pay/save-last-used-terminal/",
    STICITT_TERMINAL_PAYMENT: "sticitt_pay/sticitt_terminal_payment/",
    PEACH_TERMINAL_PAYMENT: "",
    PAYMENT_STATUS: "peachpayment/Payment-status/",

    UPDATE_STORE_STATUS: "/accounts/update/store-status",
    UPDATE_PAYMENT_MODE: (id) => `/accounts/select-payment-mode/${id}/`,
    GET_PEACH_CREDENTIAL: "/accounts/peachcredentials/",
    GET_STICITT_CREDENTIAL: "/sticitt_pay/update-sticitt-creds/",
    SET_PEACH_CREDENTIAL: "/accounts/peachcredentials/",
    SET_STICITT_CREDENTIAL: "/sticitt_pay/update-sticitt-creds/",
    GET_CREDENTIALS: "/api/credentials/",
    SET_CREDENTIALS: "/api/credentials/",
    ZAPPER_STATUS_UPDATE: "api/zapper/status-update/",
    ZAPPER_SAVE_DATA: "api/save-data/",
    SET_PEACH_TERMINAL_CREDENTIALS: "/peachpayment/updatepeach-terminal/",
    ALL_LOGISTIC_OPTIONS: "/core/logistic-service-details/",
    // UPDATE_DELIVERY_OPTION: "",
    GET_DELIVERY_LOCATION: "/accounts/add/merchant-address",
    UPDATE_DELIVERY_LOCATION: "/accounts/add/merchant-address",
    UPDATE_DELIVERY_LOCATION_BY_ID: (id) => `/accounts/update/merchant-address/${id}`,
    DELETE_DELIVERY_LOCATION: (id) => `/accounts/update/merchant-address/${id}`,
    ALL_REVIEWS: "/core/reviews/",
    TRANSACTION_DETAIL: "/customer/transaction-detail/",
    UPLOAD_BULK_CATEGORIES: "/product/bulk-upload-categories/",
    DELETE_CATEGORIY: (id) => `/product/delete-category-&-childrens/${id}`,
    UPDATE_CATEGORY: (id) => `/product/update-category/${id}`,
    SWAP_CATEGORY_DISPLAY_ORDER: "/product/category/display-order/swap/",
    DELETE_PRODUCT: (id) => `/product/delete-product/${id}`,
    DELETE_PRODUCT_VARIANT: (id) => `/product/delete-variant/${id}/`,
    UPLOAD_BULK_PRODUCTS: "/product/bulk-upload-products/",
    CREATEQR: "/accounts/qr-code/generate/",
    QRDOWNLOAD: "/accounts/qr-codes/download/",
    EXISTINGQR: "accounts/qr-code/generate/?scenario=BULK",
    SUBSCRIPTION_PLAN: "/accounts/subscription-cta-mail/",
    REFUND_ORDER: "/api/refund/",
    SEND_OTP_REFUND: "/api/refund/send-otp/",
    ADDON_GROUPS: "/product/addon-groups/",
    ADDON_GROUP: (id) => `/product/addon-groups/${id}`,
    ADDON_OPTION: (id) => `/product/addon-options/${id}/`,
    RAW_MATERIALS: "/api/raw-materials/",
    RAW_MATERIAL_DETAIL: (id) => `/api/raw-materials/${id}/`,
    GENERATE_RECIPE: "/api/generate-recipe/",
    RECIPES: "/api/recipes/",
    RECIPE_SERVING_CAPACITY: "/api/recipes/serving-capacity/",
    SELECTED_PRODUCT_SEARCH: "/customer/api/selected-product-search/",
    CART_ADDON_UPDATE: (id) => `/customer/cart/addon/${id}/`,
    CART_ADDON_REMOVE: (id) => `/customer/cart/addon/remove/${id}/`,
    VAT_BULK_APPLY: "/product/vat/bulk-apply/",
  },
  ACCOUNT: {
    ALL_PLANS: "/core/subscription-list",
    UPDATE_PLAN: "/accounts/add/merchant-subscription",
    ALL_INVOICES: "",
    EMAIL_ALERT_SETTING: "/accounts/order-mail-setting/",
    UPDATE_CUSTOMER: (id) => `/accounts/update-customer-details/${id}`,
    CREATE_SUBUSER: "/accounts/create-merchant-subuser/",
    GET_SUBUSERS: "/accounts/subusers/",
    GET_SUBUSER: (id) => `/accounts/subusers/${id}/`,
    UPDATE_SUBUSER: (id) => `/accounts/subusers/${id}`,
    DELETE_SUBUSER: (id) => `/accounts/subusers/${id}`,
    GET_FEATURES: "/api/permissions",
    GET_ALL_FEATURES: "/api/feature", // Request to check response
    PERMISSIONS: "/api/permissions",
    GET_SCREEN_PERMISSIONS: (screen) => `/api/permission?screen=${screen}`,
  },
  LANDING: {
    SUBSCRIBE: "/core/subscribe/",
    FEEDBACK: "/core/feedback/",
  },
};
